import { supabase } from './supabaseClient.js';

// Thin wrappers around the `investigate` Supabase Edge Function, which proxies
// to Claude. The user's auth JWT is attached automatically by supabase-js.

async function invoke(body) {
  const { data, error } = await supabase.functions.invoke('investigate', { body });
  if (error) {
    // Edge Function non-2xx responses surface here; try to read its JSON message.
    let msg = error.message || 'Request failed';
    try {
      const ctx = await error.context?.json?.();
      if (ctx?.error) msg = ctx.error;
    } catch {}
    throw new Error(msg);
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

export function parseInvestigation(message) {
  return invoke({
    action: 'parse',
    message,
    today: new Date().toISOString().slice(0, 10),
  });
}

export function analyzeInvestigation({ diet, startDate, endDate, windowEntries, baselineEntries }) {
  return invoke({
    action: 'analyze',
    diet,
    startDate,
    endDate,
    windowEntries,
    baselineEntries,
  });
}
